<template>
  <div
    class="card-container"
    v-loading="loading"
    element-loading-text="拼命加载中..."
    element-loading-spinner="el-icon-loading"
  >
    <common-top-form
      ref="commonTopForm"
      selectShowPower="/personalmerchant/select"
      :model="formModel"
      @success="onSuccess"
      :submitService="submitService"
      :submitData="submitData"
    >
     <el-form-item label="个人版ID">
        <el-input
          type="text"
          maxlength="11"
          v-model="formModel.userId"
          placeholder="请输入个人版ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户手机号">
        <el-input
          type="text"
          maxlength="11"
          v-model="formModel.phoneNumber"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户号">
        <el-input
          type="text"
          v-model="formModel.merNo"
          placeholder="请输入商户号"
        ></el-input>
      </el-form-item>
      <el-form-item label="绑定时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="userId"
        label="个人版ID"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="用户手机号"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merNo"
        label="商户号"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merName"
        label="商户名称"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merPhone"
        label="商户手机号"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="idCardNo"
        label="商户身份证号"
        min-width="180"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="glgId"
        label="奖励金ID"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="glgType"
        label="奖励金类型"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableDataGLG"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="绑定时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        min-width="180"
        v-if="hasPerm('/personalmerchant/del')"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="handleDel(scope.row)">删除 </el-button>
        </template>
      </el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";
import FormDialog from "../../dialog/FormDialog";

import OrganService from "service/OrganService";
import TimeRange from "service/constant/TimeRange";
import Regs from "common/conf/Regs";
import MonthNum from "service/constant/MonthNum";
import DayNum from "service/constant/DayNum";
import StatisticsService from "service/StatisticsService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters, mapActions } from "vuex";
import StorageService from "store/interfaces";

export default {
  name: "personaluser",
  data() {
    return {
      formModel: {
        phoneNumber: "",
        merNo: "",
        time: "",
      },
      tableData: [],
      submitService: OrganService.privateMemMerchantList,
      page: {},
      memInfo: {},
      isPage: false,
      loading: false,
      GLGType: [
        {
          dictKey: "11",
          dictValue: "鼓励金1",
        },
        {
          dictKey: "21",
          dictValue: "鼓励金2",
        },
        {
          dictKey: "31",
          dictValue: "鼓励金3",
        },
        {
          dictKey: "12",
          dictValue: "专享鼓励金1",
        },
        {
          dictKey: "22",
          dictValue: "专享鼓励金2",
        },
        {
          dictKey: "32",
          dictValue: "专享鼓励金3",
        },
      ],
    };
  },
  components: {
    SelectOrgans,
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
  },
  mixins: [loadMixin, dialogMixin],
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      const params = {
        phoneNumber: this.formModel.phoneNumber,
        userId: this.formModel.userId,
        merNo: this.formModel.merNo,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.time.length) {
        params.startDate = this.formModel.time[0];
        params.endDate = this.formModel.time[1];
      }
      return params;
    },
    ...mapGetters([
      "serverType",
      "tatId",
      "userId",
      "userInfo",
      "basicInfoFlag",
    ]),
  },
  watch: {},
  methods: {
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        this.loading = false;
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    handleDel(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDel(item.id);
        })
        .catch(() => {});
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    doDel(id) {
      this.doLoad(
        OrganService.privateMemMerchantDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    formatterTableDataGLG(row, column, cellValue, index) {
      let value = "";
      this.GLGType.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value == "" ? "--" : value;
    },
  },
};
</script>

<style scoped>
.parent-box {
  margin-bottom: 20px;
}

.tat-title {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.tat-title span {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/PersonalMerchant.vue